import { useState, useEffect } from "react";
import "./styles/PanelConfig.css";
import Search from "../generales/Search";
import Modal from "react-modal";
import { useFetch } from '../../hooks/useFetch';
// import Action from "../Action";
import Action from "../Action";
import LoadSimple from "../LoadSimple";
import TableAuditor from "./Auditor/TableAuditor";
import InfoPortafolio from "./Criticidad/InfoPortafolio";
import Paginador from "../generales/Paginador";
import ModalCreateTech from "./Auditor/ModalCreateTech";
// import ImportInfo from "./Proxies/ImportInfo";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'; 
import isAfter from 'date-fns/isAfter';
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import { addHours, subHours, addDays, subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addMonths } from 'date-fns';
import SelectorAdmin from "../SelectorAdmin";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "40%",
    padding: "20px",
  },
};
const ImportModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "70%",
    padding: "20px",
  },
};
const PanelEventsHistoric = ({ server,languaje,mode,handleShowPopup }) => {
  // const limitList = 200;
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResult, setSearchResult] = useState(null);
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);
  const [groupSelected,setgroupSelected]=useState([])
  const [poolRows,setPoolRows]=useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [exportLoading,setExportLoading]=useState(false)
  const dataModulos=useFetch('cassia/audit/modules','','','GET',server)
  const obtenerPrimerDiaDelMes = () => {
    const hoy = new Date();
    const primerDiaDelMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    
    const anio = primerDiaDelMes.getFullYear();
    const mes = String(primerDiaDelMes.getMonth() + 1).padStart(2, '0');
    const dia = String(primerDiaDelMes.getDate()).padStart(2, '0');
    const horas = String(primerDiaDelMes.getHours()).padStart(2, '0');
    const minutos = String(primerDiaDelMes.getMinutes()).padStart(2, '0');
  
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };
  const [opciones,setOpciones]=useState({user_email:"",module_id:0,fecha_ini:''+obtenerPrimerDiaDelMes(),fecha_fin:''+obtenerFechaActualLocal()})
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);
  const predefinedRanges = [
        {
          label: capitalizeFirstLetter(lang[languaje]['UltimaHora']),
          value: [subHours(new Date(), 1), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['Ultima3Horas']),
          value: [subHours(new Date(), 3), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['Ultima6Horas']),
          value: [subHours(new Date(), 6), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['Ultima12Horas']),
          value: [subHours(new Date(), 12), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['Ultima24Horas']),
          value: [subHours(new Date(), 24), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['Ultima48Horas']),
          value: [subHours(new Date(), 48), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['estaSemana']),
          value: [startOfWeek(new Date()), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['semanaPasada']),
          value: [subDays(new Date(), 6), new Date()],
          placement: 'left'
        },
        
        {
          label: capitalizeFirstLetter(lang[languaje]['esteMes']),
          value: [startOfMonth(new Date()), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['mesPasado']),
          value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['esteAnio']),
          value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
          placement: 'left'
        },
        {
          label: capitalizeFirstLetter(lang[languaje]['anioPasado']),
          value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
          placement: 'left'
        },
        
        
      ];
  const formatDate=(date)=>{
    const anio = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
      const dia = String(date.getDate()).padStart(2, '0');
      const horas = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');
    // console.log(`${anio}-${mes}-${dia}T${horas}:${minutos}`)
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  }
  const [range, setRange] = useState([startOfMonth(new Date()), new Date()]);
  useEffect(()=>{
    if(range!=null && range[0]!=null && range[1]!=null){
      setOpciones((prevState)=>{
   return {
       ...prevState,
       ['fecha_ini']:formatDate(range[0]),
       ['fecha_fin']:formatDate(range[1])
   }
  
})
    }
    
 
  },[range])
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  function closCreateCisModal() {
    setSearchTerm("")
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const import_info = () => {

    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setImportModalOpen(true);
   
  };
  function closeImportModal() {
    setSearchTerm("")
    setImportModalOpen(false);
    setAllSelected(false)
    setPoolRows([])
  }
  const handleChangEdit = (element) => {
    setgroupSelected(element)
    setEditActive(true);
    setCreateCisModalOpen(true)
  };
  useEffect(() => {
    // search_devices();
  }, []);


  const buscar_cis = () => {
    setSearchTerm("")
    setLoadingList(true)
    const data={
      start_date :'2024-01-01T00:00:00',
      end_date :'2024-12-31T23:59:59',
      user_email:'',
      module_id:''
    }
    const fetchDataPost = async () => {
      try {
        let baseURL=''
        baseURL = server.url+'/api/v1/cassia/audit/';
        const start_date  = '?start_date='+opciones.fecha_ini
        const end_date = '&end_date='+opciones.fecha_fin
        const user_email = (opciones.user_email=="")?'':'&user_email='+opciones.user_email
        const module_id = (opciones.module_id=="")?'':'&module_id='+opciones.module_id

        const url=baseURL+start_date+end_date+user_email+module_id
        // console.log(url)  
        const response = await fetch(
          url,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          const data1 = await response.json();
          setLoadingList(false)
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };


  const Exportar=(file_type)=>{
    
    let method='POST'
const body={
  "file_type": file_type,
  "audit_ids": poolRows
}
    setExportLoading(true)
      const fetchDataPost = async () => {
        
     try {
       // console.log(localStorage.getItem('access_token'))
       const response = await fetch(server.url+'/api/v1/cassia/audit/export', {
         method: method,  
         headers: {
            "Accept": "application/json",
           // 'Content-Type': 'application/json',
           'Content-Type': 'application/json',
             Authorization: `Bearer ${localStorage.getItem('access_token')}`,
           },
         body: JSON.stringify(body),
       });
       if (response.ok) {
        // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
     const blob = await response.blob();
     const url = window.URL.createObjectURL(blob);
     const link = document.createElement('a');
     link.href = url;

     // Dependiendo del tipo de archivo, nombramos el archivo a descargar
     if (file_type === 'json') {
       link.download = 'Tech.json';
     } else if (file_type === 'csv') {
       link.download = 'Tech.csv';
     } else if (file_type === 'excel') {
       link.download = 'Tech.xlsx'; // Archivo de Excel
     }

     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
     setAllSelected(false)
     setPoolRows([])
     setExportLoading(false);
     handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])),'', true)

       } else {
         setExportLoading(false);
         throw new Error('Error en la solicitud');
       }
     } catch (error) {
           
        }
      };
  
      fetchDataPost();
      
}

  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };
  const handleChange=(e)=>{
    const {name,value}=e.target
    setOpciones((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  const changeOption=(option,index)=>{
    setOpciones((prevState)=>{
        return {
            ...prevState,
            ['module_id']:option.value===0?null:(parseInt(option.value))
        }
        
    })
    // setManttoRelation(option.value)
  }
  const [importLoading, setImportLoading] = useState(false);
  const {user_email, module_id} = opciones;
  return (
    <>
      <div className='head-reportes' style={{height:'8%',justifyContent:'end'}}>
          {/* <div className="selected-range">
           <p>Rango seleccionado: {range[0] ? range[0].toLocaleString() : 'N/A'} - {range[1] ? range[1].toLocaleString() : 'N/A'}</p>
         </div> */}
         
            <div className='contSearchBtnrange'  style={{left:'0%',position:'relative'}}>
             <div className='compactSearchBtnrange'>
             <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['buscar'])}  action={()=>buscar_cis()}/>
           
             </div>
            
            </div>
           <div className='contSelectRangeDate' style={{left:'0%',position:'relative'}}>
               <div className="date-selector">
                   
                       <DateRangePicker
                           value={range}
                           ranges={predefinedRanges}
                           onChange={(value) => setRange(value)}
                           className="reporte-gs-datepicker"
                           placeholder="Seleccione un rango de fechas"
                           showOneCalendar={false} // Opcional: muestra solo un calendario
                           format="yyyy-MM-dd HH:mm" // Formato con horas
                           showMeridian // Si deseas mostrar el formato AM/PM
                           size='xs'
                           placement="leftStart"
                           shouldDisableDate={date => isAfter(date, new Date())}
                   />
               </div>
           </div>
           <div className='contSelectRangeDate' style={{left:'0%',position:'relative'}}>
           <div className="form-GS-box" style={{height:'40%'}}> 
                                       
                                       
                                       
                                       <div className="user-box-GS"  style={{height:'100%'}}>
                                       <input required name="user_email"  type="text" value={user_email}
                                       onChange={handleChange} placeholder="Correo" />
                                           {/* <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['correo'])}</label> */}
                                           
                                       </div>
                                       </div>
           </div>
           <div className='contSelectRangeDate' style={{left:'0%',position:'relative'}}>
           <div className="form-GS-box" style={{height:'40%',top:'-25%'}}> 
                                       
                                       
                                       
                                       <div className="user-box-GS"  style={{height:'100%'}}>
                                       {
                                               (dataModulos.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                               <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={0} origen={'Admin'} data={dataModulos.data.data}   loading={dataModulos.loading}  titulo='Modulos' selectFunction={changeOption} index={0}></SelectorAdmin>
                                           }
                                       <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['modulo'])}</label>
                                           
                                       </div>
                                       </div>
           </div>
          
               </div>
      <div className='head-cis' style={{height:'12%'}}>
       <div className='title-cis'>
                   <Search
                       searchResults={searchResults}
                       setSearchResults={setSearchResults}
                       searchTerm={searchTerm}
                       setSearchTerm={setSearchTerm}
                       onSearch={handleSearch}
                       dataObject={dataUsers.data}
                       setDataObject={setDataUsers}
                       searchResult={searchResult}
                       setSearchResult={setSearchResult}
                       languaje={languaje}
                     />
             <div className={"cont-result-registers"+mode}>
            
                     <p style={{  textAlign: "center" }}>
                       &nbsp;
                       {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                         dataList.length +
                         ") " 
                         }
                     </p> 
             </div>
             {/* <div className="cont-buttons-panel">
                     
                       <Action
                       disabled={false}
                       origen="Azul"
                       titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                       action={crear}
                     />
                     
                     
                   </div>
                   <div className="cont-buttons-panel" style={{right:'15%'}}>
                     
                    
                   
                   
                   <Action
                       disabled={false}
                       origen="Cielo"
                       titulo={" "+capitalizeFirstLetter(lang[languaje]['importar'])}
                       action={import_info}
                     />
    
                 </div> */}
                   </div>
                   
               </div>
      <div className='cont-cis' style={{height:'80%'}}>
      <>
<div className="main-panel-cis">
<div className="compact-content-portafolio">
<div className={"content-portafolio-head"+mode}>
  {
  // (contRowsSelected!=0)?
    <>
    {(exportLoading)?<div className="cont-excels-buttons-portafolio cont-result-registers"  style={{position:'absolute'}}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div>:
    <>
    {/* {(contRowsSelected==0)?<div className="cont-excels-buttons-portafolio" style={{position:'absolute',background:'#62626233',zIndex:'2'}}></div>:''} */}
    <div className="cont-excels-buttons-portafolio" style={{position:'absolute'}}>
    <div className="half-excels-buttons-portafolio">
                  
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/csv_icon.png"}
              name="regresar"
              onClick={()=>Exportar('csv')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                    {'CSV  '}
                  </div>
                </div>
               <div className="half-excels-buttons-portafolio">
                  
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/json_icon.png"}
              name="regresar"
              onClick={()=>Exportar('json')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                    {'JSON'}
                  </div>
                </div>
                <div className="half-excels-buttons-portafolio">
                
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/xsl_icon.png"}
              name="regresar"
              onClick={()=>Exportar('excel')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                  {'EXCEL'}
                  </div>
                </div>
           </div>
     </>
    }
    </>
    // :''
        }
        </div>
  <div className="content-portafolio">
    <div className="cont-portafolio-table">
      <div className="content-card-portafolio" id="content">
        {(exportLoading || importLoading) ? (
          <LoadSimple />
        ) : (
          <>
            {cisSelected.length === 0 ? (
              <TableAuditor
                pageActual={pageActual}
                 limitList={limitList} startLimit={startLimit}
                dataList={dataList}
                cisSelected={cisSelected}
                setCisSelected={setCisSelected}
                registerIsValid={registerIsValid}
                searchResults={searchResults}
                setSearchResults={setSearchResults}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                dataUsers={dataUsers}
                setDataUsers={setDataUsers}
                server={server}
                setRegisterIsValid={setRegisterIsValid}
                setData={setData}
                setLoading={setLoading}
                setError={setError}
                handleChangEdit={handleChangEdit}
                devices={devices}
                languaje={languaje}
                mode={mode}
                setContRowSelected={setContRowSelected}
                poolRows={poolRows}
                setPoolRows={setPoolRows}
                allSelected={allSelected}
                setAllSelected={setAllSelected}
                handleShowPopup={handleShowPopup}
                buscar_cis={buscar_cis}
                loadingList={loadingList}
              ></TableAuditor>
            ) : (
              ("")
              // <InfoPortafolio
              //   server={server}
              //   portfolioSelected={cisSelected}
              //   searchResults={searchResults}
              //   setSearchResults={setSearchResults}
              //   searchTerm={searchTerm}
              //   setSearchTerm={setSearchTerm}
              //   onSearch={handleSearch}
              //   dataUsers={dataUsers}
              //   setDataUsers={setDataUsers}
              //   setCisSelected={setCisSelected}
              //   registerIsValid={registerIsValid}
              // ></InfoPortafolio>
            )}
          </>
        )}
      </div>
    </div>

    </div>
    <div className={"content-portafolio-footer"+mode}>
    <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
      
      <div className={"cont-half-display-paginador"+mode}>
      <p style={{  textAlign: "center" }}>
                      &nbsp;
                      {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                </p> 
            
      </div>
    </div>  
    <div className="cont-display-paginador">
              <Paginador  pages={pages}
                          pageActual={pageActual}
                          setPageActual={setPageActual}
                          mode={mode}></Paginador>
    </div>
    <div className="cont-display-paginador">
      <div className={"cont-half-display-paginador"+mode}>
                
      <div>
<label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
<select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
  <option value={10}>10</option>
  <option value={50} >50</option>
  <option value={100}>100</option>
  <option value={500}>500</option>
  <option value={1000}>1000</option>
</select>


</div>
      </div>
      <div className={"cont-half-display-paginador"+mode}>
      <p style={{  textAlign: "center" }}>
                      &nbsp;
                      {"(" +
                  (startLimit + 1) +
                  " - " +
                  (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                    ?  parseInt(pageActual ) * parseInt(limitList)
                    : dataList.length) +
                  ")  "+lang[languaje]['de']+" " +
                  dataList.length +
                  " "+lang[languaje]['resultados']}
                </p>
            
      </div>
    </div>  
              
  </div>
  </div>
</div>
<Modal
  isOpen={CreateCisModalOpen}
  // isOpen={false}
  // onAfterOpen={afterOpenExeption}
  onRequestClose={closCreateCisModal}
  style={CreateCisModalStyles}
  contentLabel="Example Modal2"
  // shouldCloseOnOverlayClick={false}
>
<ModalCreateTech
devices={devices}
server={server}
editActive={editActive}
setEditActive={setEditActive}
dataCis={dataCis}
setData={setData}
loading={loading}
setLoading={setLoading}
setError={setError}
dataUsers={dataUsers}
setRegisterIsValid={setRegisterIsValid}
closCreateCisModal={closCreateCisModal}
groupSelected={groupSelected}
languaje={languaje}
mode={mode}
setSearchTerm={setSearchTerm}
handleShowPopup={handleShowPopup}
></ModalCreateTech>
</Modal>

{/* <Modal
  isOpen={ImportModalOpen}
  // isOpen={false}
  // onAfterOpen={afterOpenExeption}
  onRequestClose={closeImportModal}
  style={ImportModalStyles}
  contentLabel="Example Modal2"
  shouldCloseOnOverlayClick={false}
>
<ImportInfo
server={server}
importLoading={importLoading}
setImportLoading={setImportLoading}
closeImportModal={closeImportModal}
languaje={languaje}
mode={mode}
handleShowPopup={handleShowPopup}
></ImportInfo>
</Modal> */}
</>
          
      </div>
    </>
  );
};

export default PanelEventsHistoric;
